export enum PriceListStatus {
  Active = "active",
  Inactive = "inactive",
  ActiveDuringPeriod = "active_during_period",
}
